import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import useSETrackEvent from 'app/SearchPage/hooks/useSETrackEvent'
import {
  useContentSearchFilter,
  useContentSearchTracker,
} from 'stores/content-search'

const SearchResultFilterNudge = () => {
  const contentSearchFilterStore = useContentSearchFilter()
  const contentSearchTrackerStore = useContentSearchTracker()
  const { SETrackSearchResultsPage } = useSETrackEvent()

  const clickHandler = React.useCallback(() => {
    contentSearchFilterStore.setSheetOpen(true)
    SETrackSearchResultsPage('CLICK_SELECT_CATEGORY_SEARCH_NUDGE', {
      event_trigger: contentSearchTrackerStore.eventTrigger,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="flex items-end justify-between relative bg-surface-selected-default">
      <div className="p-4 pr-0">
        <Text variant="action">Masih belum ketemu?</Text>
        <Text variant="body-sm" color="subdued" className="mb-4">
          Pakai kategori untuk menyeleksi hasil pencarian, yuk.
        </Text>
        <Button
          color="white"
          className="!bg-transparent"
          size="sm"
          variant="solid"
          onClick={clickHandler}
        >
          Pilih kategori
        </Button>
      </div>
      <div className="flex-none bg-[url('/images/errors/img-unmatched-filter-document-no-circle.png')] bg-contain bg-no-repeat right-0 bottom-0 w-[120px] h-[120px]" />
    </div>
  )
}

export default SearchResultFilterNudge
